<article class="formEditor">
    @if (labelText()) {
        <span class="formLabel">{{ labelText() }}</span>
    }
    <lib-dropdown-range-values
        [valueFrom]="valueFrom()"
        [valueTo]="valueTo()"
        (valueFromChange)="onValueFromChange($event)"
        (valueToChange)="onValueToChange($event)"
        (applyClicked)="onApplyClicked()"
        (clearClicked)="onClearClicked()"
        [placeholder]="placeholderText()"
        [minValue]="minValue()"
        [maxValue]="maxValue()"
        [iconType]="iconType()"
    >
    </lib-dropdown-range-values>
</article>
